module.exports = __webpack_public_path__ + "img/1.aa92ce58.png";